export default __webpack_public_path__ + "static/media/delete.7a7ddf7c.svg";